import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';
import Tooltip from './Tooltip';

/**
 * Small link icon marking a TOC element that is paired to a parent portfolio.
 * Hovering explains who the element is linked to; falls back to a generic
 * label when the portfolio name can't be resolved.
 *
 * @param {object} props
 * @param {string} [props.portfolioName] - Display name of the linked portfolio
 */
const LinkedBadge = ({ portfolioName }) => (
    <span className="linked-badge">
        <Tooltip content={portfolioName ? `Gekoppeld aan ${portfolioName}` : 'Gekoppeld aan portfolio'}>
            <LinkOutlinedIcon className="linked-badge__icon" />
        </Tooltip>
    </span>
);

export default LinkedBadge;
